import { render } from "./MetaManager.vue?vue&type=template&id=37afe5ba"
import script from "./MetaManager.vue?vue&type=script&lang=js"
export * from "./MetaManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__